var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        // 'c-table_scrolled': isScrolled,
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
      },
    },
    [
      _c("m-column-filters", {
        ref: "columnFilters",
        attrs: {
          column: _vm.filteredColumn,
          referenceList: _vm.referenceList,
          activeFilters: _vm.activeFilteredColumns,
        },
        on: {
          getReferenceValues: _vm.getReferenceValues,
          close: function ($event) {
            _vm.filteredColumn = null
          },
          setFilter: _vm.setColumnFilter,
          removeFilter: _vm.removeColumnFilter,
        },
      }),
      _vm.data.records.length !== 0
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow_active": _vm.data.actions,
              // 'c-table__empty__shadow': data.records.length === 0
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c(
        "perfect-scrollbar",
        {
          ref: "wrapper",
          staticClass: "c-table__wrapper",
          on: { scroll: _vm.scroll },
        },
        [
          _c(
            "table",
            {
              ref: "container",
              staticClass: "c-table__container",
              attrs: { id: "tableWithFixedFirstColumn" },
            },
            [
              _c(
                "thead",
                { ref: "header", staticClass: "c-table__header" },
                _vm._l(_vm.levels, function (i) {
                  return _c(
                    "tr",
                    { key: i, staticClass: "c-table__header-row" },
                    [
                      _vm._l(_vm.getTableColumns(i), function (column) {
                        return _vm.isLatenessShow(column)
                          ? _c(
                              "th",
                              {
                                key: column.id,
                                staticClass: "c-table__column",
                                class: {
                                  "c-table__column_with_filter": column.type,
                                  "c-table__column_border_left":
                                    _vm.data.type ===
                                      "new-calculation-lateness" &&
                                    column.id ===
                                      _vm.getFirstInTotalChildColumn(),
                                  "c-table__column_hidden": _vm.isDisabled(
                                    column.id
                                  ),
                                  "c-table__column_sorted":
                                    _vm.isSorted(column),
                                },
                                attrs: {
                                  colspan: _vm.getColspan(column),
                                  rowspan: _vm.getRowspan(column),
                                  id: `c-table-column-${column.id}`,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "c-table__column-wrapper" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "c-table__column-label",
                                        class: {
                                          "c-table__column-label-children":
                                            !_vm.isCategory(column) &&
                                            _vm.sortedColumn,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSortedColumn(
                                              column,
                                              _vm.sortedColumn
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(column.label))]
                                    ),
                                    (column.description || column.type) &&
                                    _vm.data.type !== "new-calculation-lateness"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-table__column-actions",
                                          },
                                          [
                                            column.fullName
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-action c-table__column-action_description",
                                                  },
                                                  [
                                                    _c("c-button", {
                                                      attrs: {
                                                        size: "small",
                                                        icon: "info",
                                                        id: `table-column-button-description-${column.id}`,
                                                        noBorder: "",
                                                      },
                                                    }),
                                                    _c(
                                                      "b-popover",
                                                      {
                                                        attrs: {
                                                          placement: "top",
                                                          triggers: "hover",
                                                          target: `table-column-button-description-${column.id}`,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.fullName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.isColumnFiltered(column.id)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-action",
                                                  },
                                                  [
                                                    _c("c-button", {
                                                      attrs: {
                                                        size: "small",
                                                        noBorder: "",
                                                        id: `table-column-button-filter-${column.id}`,
                                                        active:
                                                          _vm.isColumnActiveFiltered(
                                                            column.id
                                                          ),
                                                        icon: {
                                                          icon: "filter-column",
                                                          activeColor: "blue",
                                                        },
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openColumnFilterModal(
                                                            column
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "b-popover",
                                                      {
                                                        attrs: {
                                                          placement: "top",
                                                          triggers: "hover",
                                                          target: `table-column-button-filter-${column.id}`,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.isColumnActiveFiltered(
                                                                column.id
                                                              )
                                                                ? "Изменить фильтр"
                                                                : "Применить фильтр"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e()
                      }),
                      _vm.data.actions && i === 1
                        ? _c(
                            "th",
                            {
                              staticClass:
                                "c-table__column c-table__column_actions",
                              attrs: { rowspan: _vm.levels },
                            },
                            [
                              _c("div", {
                                staticClass: "c-table__column-empty",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
              _c(
                "tbody",
                { staticClass: "c-table__records" },
                _vm._l(_vm.data.records, function (record, recordIndex) {
                  return _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: record.isShowRow,
                          expression: "record.isShowRow",
                        },
                      ],
                      key: recordIndex,
                      staticClass: "c-table__record",
                    },
                    [
                      _vm.data.type === "new-calculation-lateness"
                        ? _c(
                            "td",
                            {
                              staticClass:
                                "c-table__cell_total c-table__cell c-table__cell_number",
                              class: {
                                "c-table__cell__grey": _vm.isGreyCell(
                                  _vm.data.type,
                                  "total",
                                  record.isTotalRow
                                ),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "c-table__cell-value" },
                                [_vm._v(_vm._s(record["total"].value))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._l(
                        _vm.getTableColumns(_vm.levels),
                        function (column) {
                          return _vm.isLatenessShow(column)
                            ? _c(
                                "td",
                                {
                                  key: column.id,
                                  staticClass: "c-table__cell",
                                  class: {
                                    "c-table__cell__yellow": _vm.isYellowCell(
                                      _vm.data.type,
                                      column.id,
                                      record[column.id].value,
                                      record.isTotalRow
                                    ),
                                    "c-table__cell__red": _vm.isRedCell(
                                      _vm.data.type,
                                      column.id,
                                      record[column.id].value,
                                      record.isTotalRow
                                    ),
                                    "c-table__cell__green": _vm.isGreenCell(
                                      _vm.data.type,
                                      column.id,
                                      record[column.id].value,
                                      record.isTotalRow
                                    ),
                                    "c-table__cell__grey": _vm.isGreyCell(
                                      _vm.data.type,
                                      column.id,
                                      record.isTotalRow,
                                      record.isTotalRow
                                    ),
                                    "c-table__cell_border_left":
                                      _vm.data.type ===
                                        "new-calculation-lateness" &&
                                      column.id ===
                                        _vm.getFirstInTotalChildColumn(),
                                    "c-table__cell_string":
                                      column.type === "string",
                                    "c-table__cell_reference":
                                      column.type === "reference",
                                    "c-table__cell_number":
                                      column.type === "number",
                                    "c-table__cell_date":
                                      column.type === "date",
                                    "c-table__cell_hidden": _vm.isDisabled(
                                      column.id
                                    ),
                                    ["c-table__cell_" + column.id]: column.id,
                                  },
                                  style: {
                                    background: _vm.getLatenessColor(
                                      column.id,
                                      record.isTotalRow,
                                      record[column.id].value
                                    ),
                                  },
                                },
                                [
                                  _vm.isLatenessCell(
                                    column.id,
                                    record.isTotalRow
                                  )
                                    ? _c("c-table-lateness-cell", {
                                        attrs: {
                                          record: record,
                                          "column-id": column.id,
                                          "column-label": column.label,
                                          "parent-column-id":
                                            column.parentColumnId,
                                          "calculation-data": _vm.calcData,
                                          "can-edit": _vm.canEdit,
                                        },
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "c-table__cell-value",
                                          class: {
                                            "c-table__cell-value__grey":
                                              _vm.data.type ===
                                                "new-calculation-lateness" &&
                                              _vm.isTotalValuesLateness(
                                                column.id
                                              ),
                                          },
                                          style: {
                                            "text-align":
                                              _vm.data.type ===
                                                "new-calculation-lateness" &&
                                              column.id !== "load_sushiChef" &&
                                              column.id !== "load_hotShop"
                                                ? "center"
                                                : "right",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(record[column.id].value)
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              )
                            : _vm._e()
                        }
                      ),
                      _vm.data.actions
                        ? _c(
                            "td",
                            {
                              staticClass:
                                "c-table__cell c-table__cell_actions",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "c-table__cell-actions" },
                                [
                                  _vm.data.type === "employees"
                                    ? _c("c-table-actions", {
                                        attrs: {
                                          type: _vm.data.type,
                                          record: record,
                                          recordIndex: recordIndex,
                                          recordCount: _vm.data.records.length,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
      _vm.data.records.length === 0
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(_vm._s(_vm.emptyRecordsLabel)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }